@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.items-section-content {
  padding: @space-0 @space-0 @space-16 @space-0;
}

.items-list-container {
  padding: @space-0;
}

.no-items-message {
  font-style: italic;
  color: @orders-drawer--order-items--no-items--text-color;
  text-align: center;
}
